import { render, staticRenderFns } from "./chengZu.vue?vue&type=template&id=8137a000&scoped=true&"
import script from "./chengZu.vue?vue&type=script&lang=js&"
export * from "./chengZu.vue?vue&type=script&lang=js&"
import style0 from "./chengZu.vue?vue&type=style&index=0&id=8137a000&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8137a000",
  null
  
)

export default component.exports